import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AppSettingService } from '../services/app-setting.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ManagePracticeService {


  constructor(private http: HttpClient) { }

  getCounselorList(): Observable<any> {
    return this.http
      .get(AppSettingService.getCounselorsUri ).pipe(catchError(this.error));

  }


  getCounselor(counselorId:any): Observable<any> {
    return this.http
      .get(AppSettingService.getCounselorUri +"?Id="+counselorId).pipe(catchError(this.error));

  }
  addCounselor(model:any): Observable<any> {
    return this.http
      .post(AppSettingService.addCounselorUri ,model).pipe(catchError(this.error));

  }

  deleteCounselor(id:any): Observable<any> {
    return this.http
      .get(AppSettingService.deleteCounselorUri +"?id="+id).pipe(catchError(this.error));

  }
  getBadges(): Observable<any> {
    return this.http
      .get(AppSettingService.getProviderBadgesUri ).pipe(catchError(this.error));

  }
  addPracticeInformation(model:any): Observable<any> {
    return this.http
      .post(AppSettingService.updatepracticeinformationdetailUri ,model).pipe(catchError(this.error));

  }

  getProviderSiteList(): Observable<any> {
    return this.http
      .get(AppSettingService.getProviderSitesUri ).pipe(catchError(this.error));

  }

  getProviderSite(counselorId:any): Observable<any> {
    return this.http
      .get(AppSettingService.getProviderSiteUri +"?Id="+counselorId).pipe(catchError(this.error));

  }
  addProviderSite(model:any): Observable<any> {
    return this.http
      .post(AppSettingService.addProviderSiteUri ,model).pipe(catchError(this.error));

  }

  getProviderAddress(addressType:any): Observable<any> {
    return this.http
      .get(AppSettingService.getProviderAddressUri +"?addressType="+addressType).pipe(catchError(this.error));

  }
  getPracticeInformationDetail()
  
  {
    return this.http
    .get(AppSettingService.getPracticeInformationDetailUri ).pipe(catchError(this.error));

  }
  error(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(error);
    return throwError({ error: error.error, status: error.status });
  }
}